"use strict";
/* globals module */
/**
 * @module meteringACLClient
 * @description  Metering ACL Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringACLClient` uses `meteringACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var MeteringACLClient = /** @class */ (function () {
    function MeteringACLClient(meteringACLRoute, apiClient) {
        this.meteringACLRoute = meteringACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified metering resource.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example meteringClient.get({id: '<id>'})
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    MeteringACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified metering resource.
     * @method
     * @param options ACL options object.
     * @example let options = {id : '<id>'};
                let aclObj =  {  actionId: '<action-id'>,  roleId: '<roleId>',  userId: '<userId>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                meteringACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                      function (response, status, headers, config) {
                          // perform error handling here
                    });
     **/
    MeteringACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and metering resource.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example meteringACLClient.removeByUser('<id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringACLClient.prototype.removeByUser = function (id, action, user, data) {
        return this.apiClient.delete(this.meteringACLRoute.deleteByUser(id, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and metering resource.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example meteringACLClient.removeByRole('<id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringACLClient.prototype.removeByRole = function (id, action, role, data) {
        return this.apiClient.delete(this.meteringACLRoute.deleteByRole(id, action, role, data));
    };
    var _a, _b;
    MeteringACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringACLRoute !== "undefined" && _1.MeteringACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringACLClient);
    return MeteringACLClient;
}());
exports.MeteringACLClient = MeteringACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
